import {FormControl, FormField} from 'platform/components';
import {HStack, VStack, Text} from 'platform/foundation';

import {StageSequenceDefinitionResponseBody} from '@dms/api/settings';

import {MandatoryFieldsRequestFormSchemaType} from '../schemas/MandatoryFieldsFormSchema';

interface MandatoryFieldsItemSequenceProps {
  stageSequence: StageSequenceDefinitionResponseBody;
  fieldId: string;
  control: FormControl<MandatoryFieldsRequestFormSchemaType>;
  defaultValues: Partial<MandatoryFieldsRequestFormSchemaType>;
}

export function MandatoryFieldsItemSequence(props: MandatoryFieldsItemSequenceProps) {
  const sequenceOptions =
    props.stageSequence?.stages?.map((stage) => ({
      label: stage.name,
      value: stage.id,
    })) ?? [];

  return (
    <VStack spacing={2} key={props.stageSequence.id}>
      <Text size="xSmall">{props.stageSequence.name}</Text>

      <HStack spacing={2}>
        <FormField
          isRequired
          isDeselectable
          type="chips"
          name={`fields.${props.fieldId}.stages.${props.stageSequence.id}`}
          control={props.control}
          options={sequenceOptions}
        />
      </HStack>
    </VStack>
  );
}
